import { render, staticRenderFns } from "./ConsultaPendencias.vue?vue&type=template&id=fcd046ea"
import script from "./ConsultaPendencias.vue?vue&type=script&lang=js"
export * from "./ConsultaPendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports